import { Modal } from 'iview'
var DEFAULT_CONFIG = {
  'class-name': 'modal-middle'
}

/* let modalInstance

function getModalInstance (options) {
  console.log(Modal)
  modalInstance = modalInstance || Modal.newInstance(Object.assign({}, options, DEFAULT_CONFIG))

  return modalInstance
} */

function confirm (options) {
  console.log(this)
  Modal.confirm(Object.assign({}, DEFAULT_CONFIG, options))
}

var IviewModal = {
  confirm
}

export default IviewModal



// WEBPACK FOOTER //
// ./src/third/Modal.js